<template>
  <div id="content" :class="device.isIPhoneX && from == 'index' ? 'content-x' : ''">
    <template v-for="(item, index) in bookContent">
      <!-- 区域模板 start-->
      <templatIndex :key="item.key" v-if="item.type === 'template'" :content="item"></templatIndex>
      <!-- 区域模板 end-->
      <!-- 段落模板 start-->
      <paragraphIndex :key="item.key" v-if="item.type === 'paragraph'" :content="item"></paragraphIndex>
      <!-- 段落模板 end-->
      <frontPage :key="item.key" v-if="item.type === 'frontPage'" :content="item"></frontPage>
      <timeLine :key="item.key" v-if="item.type === 'timeLine'" :content="item"></timeLine>
      <title2 :key="item.key" v-if="item.type === 'title-2'" :content="item"></title2>

      <!-- 标题 start-->
      <titleIndex :key="item.key" v-if="item.type === 'title'" :content="item"></titleIndex>
      <!-- 标题 end-->
      <!-- 文本内容 start-->
      <textIndex :key="item.key" v-if="item.type === 'text'" :content="item" :isInTable="item.isInTable"></textIndex>
      <!-- 文本内容 end-->
      <!-- 特殊段落文字 start-->
      <textIndexSpecial :key="item.key" v-if="item.type === 'text-special'" :content="item"></textIndexSpecial>
      <!-- 特殊段落文字 end-->
      <!-- 多媒体 包含图片、视频、音频、三维模型 start-->
      <mediaIndex :key="item.key" v-if="mediaTypeArr.includes(item.type)" :content="item"></mediaIndex>
      <!-- 多媒体 end-->
      <!-- 脑图 start-->
      <mindMapIndex :key="item.key" v-if="item.type === 'mindMap'" :content="item"></mindMapIndex>
      <!-- 脑图 end-->
      <!-- 表格 start-->
       <template v-if="item.type === 'table'">
        <tableEditEn v-if="item.styleType === 3" :key="item.key" :content="item" :ref="item.key"></tableEditEn>
        <tableIndex v-else :key="item.key" :content="item" :ref="item.key"></tableIndex>
       </template>
      <!-- 表格 end-->
      <!-- 答题功能 start-->
      <questionIndex :key="item.key" v-if="item.type === 'question'" :content="item"></questionIndex>
      <!-- 答题功能 end-->
      <!-- 答题功能 start-->
      <questionInteraction :key="item.key" v-if="item.type === 'interactionQuestion'" :content="item"></questionInteraction>
      <!-- 答题功能 end-->
      <!-- 交互功能 start-->
      <actionIndex class="content_action" :key="item.key" v-if="item.type === 'action'" :content="item"></actionIndex>
      <!-- 交互功能 end-->
      <!-- 混合弹窗 目前只是示例项目的第二章第二节的功能介绍模块 start-->
      <mixPopupIndex :key="item.key" v-if="item.type === 'mix-popup'" :content="item"></mixPopupIndex>
      <!-- 混合弹窗 end-->
      <!-- 特殊模块 目前只有示例项目的介绍模块 start-->
      <specialIndex :key="item.key" v-if="item.type === 'special'" :content="item"></specialIndex>
      <!-- 特殊模块 end-->
      <!-- 任务工单 start-->
      <workOrderIndex :key="item.key" v-if="item.type === 'workOrder'" :content="item"></workOrderIndex>
      <!-- 任务工单 end-->
      <frameIndex :key="item.key" v-if="item.type === 'frame'" :content="item"></frameIndex>
      <!-- 列表 start-->
      <listIndex :key="item.key" v-if="item.type === 'list'" :content="item"></listIndex>
      <!-- 列表 end-->
      <!-- 任务实施 start-->
      <taskEffect :key="item.key" v-if="item.type === 'taskEffect'" :content="item"></taskEffect>
      <!-- 任务实施 end-->
      <!-- 录音播放 start-->
      <sound :key="item.key" v-if="item.type === 'sound'" :content="item"></sound>
      <!-- 录音播放 end-->
      <!-- 英语展开收起菜单 start -->
      <expandMenu :key="item.key" v-if="item.type === 'expandMenu'" :content="item"></expandMenu>
      <!-- 英语展开收起菜单 end -->
      <!-- 单词音频播放 start -->
      <wordAudio :key="item.key" v-if="item.type === 'wordAudio'" :content="item"></wordAudio>
      <!-- 单词音频播放 end -->
      <!-- 翻译音频播放 start -->
      <translationAudio :key="item.key" v-if="item.type === 'translationAudio'" :content="item"></translationAudio>
      <!-- 翻译音频播放 end -->
      <!-- 英语判断题 start -->
      <trueOrFalse :key="item.key" v-if="item.type === 'trueOrFalse'" :content="item"></trueOrFalse>
      <!-- 英语判断题 end -->
      <!-- 英语中带图片的选择题 start -->
      <selectWithImage :key="item.key" v-if="item.type === 'selectWithImage'" :content="item"></selectWithImage>
      <!-- 英语中带图片的选择题 end -->
      <!-- tabs二级切换的音频播放 start -->
      <switchAudio :key="item.key" v-if="item.type === 'switchAudio'" :content="item"></switchAudio>
       <!-- tabs二级切换的音频播放 end -->
       <!-- <evaluationIndex :key="item.key" v-if="item.type === 'evaluationIndex'" :content="item"></evaluationIndex> -->
       <ulFlex :key="item.key" v-if="item.type === 'ulflex'" :content="item"></ulFlex>
    </template>
  </div>
</template>
<script>
/**
 *
 * 整体模板的引入
 * 目前templateIndex、tableIndex、textIndex中的popover、listIndex存在循环调用当前模块
 */
import templateIndex from "./components/template/index.vue";
import paragraphIndex from "./components/paragraph/index.vue";
import frontPage from "./components/frontPage.vue";
import timeLine from "./components/timeLine.vue";
import title2 from "./components/title-2.vue";

import titleIndex from "./components/title/index.vue";
import textIndex from "./components/text/index.vue";
import textIndexSpecial from "./components/text/indexSpecial.vue";
import mediaIndex from "./components/media/index.vue";
import mindMapIndex from "./components/mindMap/index.vue";
import tableIndex from "./components/table/index.vue";
import tableEditEn from "./components/table/tableEditEn.vue";
import questionIndex from "./components/question/index.vue";
import questionInteraction from "./components/question/interactionEn.vue";
import actionIndex from "./components/action/index.vue";
import mixPopupIndex from "./components/mixPopup/index.vue";
import specialIndex from "./components/special/index.vue";
import workOrderIndex from "./components/workOrder/index.vue";

import frameIndex from "./components/frame/index.vue";
import taskEffect from "./components/taskEffect/index.vue";

import listIndex from "./components/list/index.vue";
import sound from "./components/sound/index.vue";
import expandMenu from "./components/sound/expandMenu.vue";
import wordAudio from "./components/sound/wordAudio.vue";
import translationAudio from "./components/sound/translationAudio.vue";
import trueOrFalse from "./components/question/trueOrFalse.vue";
import selectWithImage from "./components/question/selectWithImage.vue";
import switchAudio from "./components/sound/switchAudio.vue";
import evaluationIndex from "./components/evaluation/index.vue";//英语最后一节
import ulFlex from "./components/list/ulflex.vue";
export default {
  name: "contentIndex",
  components: {
    templatIndex: templateIndex,
    paragraphIndex,
    frontPage,
    timeLine,
    title2,
    titleIndex,
    textIndex,
    textIndexSpecial,
    mediaIndex,
    mindMapIndex,
    tableIndex,
    tableEditEn,
    questionIndex,
    questionInteraction,
    actionIndex,
    mixPopupIndex,
    specialIndex,
    workOrderIndex,
    frameIndex,//带框的文字、内容、答题
    taskEffect,//任务实施
    listIndex,//列表
    sound,//录音播放
    expandMenu,//英语展开收起菜单
    wordAudio,//单词音频播放
    translationAudio,//翻译音频播放
    trueOrFalse, //英语判断题
    selectWithImage, //英语中带图片的选择题
    switchAudio,//tabs二级切换的音频播放
    evaluationIndex,//英语最后一节
    ulFlex
  },
  props: {
    bookContent: {
      type: Array,
      default: () => {
        return [];
      }
    },
    from: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      mediaTypeArr: ['image', 'video', 'audio', '3DModel'],
    }
  },
  mounted() {

  },
  methods: {
    tableTabChange(tableKey, tableTabKey){
      this.$refs[tableKey][0].changeTabs(tableTabKey)
    },
  },
}
</script>

<style lang="scss" scoped>
.content_action {
  width: calc(100% - 48rem);
  margin: 20rem auto;
}
.content-x{
  padding-bottom: 34rem;
}
</style>
